import React, { useState, useRef, useEffect } from "react";
import {
  Avatar,
  Box,
  IconButton,
  Typography,
  Tooltip,
  Divider
} from "@mui/material";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
import EditProfileDialog from "../pages/Profile/EditProfile";
import { IMAGE_URL } from "../services/api";
import { getUserInfoFromToken } from "../utils/authUtils";
import ProtectedImage from "./ProtectedImage";

export default function AccountSettings({ userDetails, onLogout }) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [showDialog, setShowDialog] = useState(false);
  const [userType, setUserType] = useState(null);
  const [userId, setUserId] = useState(null);
  console.log("Userdetails",userDetails);
  

  const handleProfileClick = () => {
    setShowDialog(true);
  };
  const toggleDropdown = () => {
    setOpen(!open);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setOpen(false);
    }
  };
  // const userType = localStorage.getItem("user_type");

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const formikRef = useRef();
        useEffect(() => {
        const { userType, userId } = getUserInfoFromToken();
        setUserType(userType);
        setUserId(userId);
      }, []);
  

  return (
    <Box
      sx={{ position: "relative", display: "inline-block" }}
      ref={dropdownRef}
    >
      <Tooltip title="Account Settings">
        <IconButton onClick={toggleDropdown}>
  <Avatar
    sx={{
      width: 36,
      height: 36,
    }}
  >
    {userDetails?.profile_data?.profile_image ? (
      <ProtectedImage
        path={userDetails.profile_data.profile_image}
        alt={`${userDetails?.first_name || ""} ${userDetails?.last_name || ""}`}
        style={{
          width: "100%",
          height: "100%",
          borderRadius: "50%",
          objectFit: "cover",
        }}
      />
    ) : (
      // Fallback initials
      `${userDetails?.first_name?.[0] || ""}${userDetails?.last_name?.[0] || ""}`.toUpperCase()
    )}
  </Avatar>
</IconButton>

      </Tooltip>

      {open && (
        <Box
          sx={{
            position: "absolute",
            right: 0,
            mt: 1,
            width: 220,
            bgcolor: "#fff",
            boxShadow: 3,
            borderRadius: 2,
            zIndex: 1000,
            p: 1.5,
            
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
            {userDetails?.profile_data?.profile_image ? (
  <ProtectedImage
    path={userDetails?.profile_data?.profile_image}
    alt={`${userDetails?.first_name || ""} ${userDetails?.last_name || ""}`}
    style={{
      width: "36px",
      height: "36px",
      borderRadius: "50%",
      objectFit: "cover",
      marginRight: "12px",
    }}
  />
) : (
  <Avatar sx={{ width: 36, height: 36 }}>
    {`${userDetails?.first_name?.[0] || ""}${userDetails?.last_name?.[0] || ""}`.toUpperCase()}
  </Avatar>
)}

            <Box sx={{ ml: 1 }}>
              <Typography
                variant="subtitle2"
                sx={{
                  fontSize: "15px",
                  fontWeight: 500,
                  color: "#374151", // Tailwind gray-700
                  lineHeight: 0.8
                }}
              >
               {`${userDetails?.first_name} 
                  ${userDetails?.last_name}`}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {`${
                  userDetails?.employee_id ? userDetails.employee_id : userType
                }`}
              </Typography>
            </Box>
          </Box>
          <Divider />

          <Box sx={{ py: 1 }}>
            <Box sx={menuItemStyle} onClick={handleProfileClick}>
              <PersonAddIcon sx={{ mr: 1 }} />
              <Typography variant="body2">Profile</Typography>
            </Box>


            <Box
              sx={menuItemStyle}
              onClick={() => console.log("Settings clicked")}
            >
              <SettingsIcon sx={{ mr: 1 }} />
              <Typography variant="body2">Settings</Typography>
            </Box>

            <Box sx={menuItemStyle} onClick={onLogout}>
              <LogoutIcon sx={{ mr: 1 }} />
              <Typography variant="body2">Logout</Typography>
            </Box>
          </Box>
        </Box>
      )}
      <EditProfileDialog
        open={showDialog}
        handleClose={() => setShowDialog(false)}
        // userDetails={userDetails}
      />
    </Box>
  );
}

const menuItemStyle = {
  display: "flex",
  px: 2,
  py: 1.2,
  borderRadius: "8px",
  color: "#4B5563", // Tailwind's gray-600
  fontSize: "15px",
  fontWeight: 500,
  cursor: "pointer",
  transition: "background 0.2s ease",
  "&:hover": {
    backgroundColor: "#F3F4F6" // Tailwind's gray-100
  }
};
